/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Grower_Report_Total_HeadingInputs */

const vi_my_grower_report_total_heading = /** @type {(inputs: My_Grower_Report_Total_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng cộng`)
};

/**

* @param {My_Grower_Report_Total_HeadingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_total_heading = /** @type {((inputs?: My_Grower_Report_Total_HeadingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_Total_HeadingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_total_heading(inputs)
});